import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

interface PremiumFeatureProps {
  children: React.ReactElement<{ disabled?: boolean; onClick?: (e: React.MouseEvent<HTMLElement>) => void }>;
  featureName: string;
  disabled?: boolean;
}

export function PremiumFeature({ children, featureName, disabled = false }: PremiumFeatureProps) {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleUpgrade = () => {
    setOpen(false);
    navigate('/payment');
  };

  return (
    <>
      <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
        {React.cloneElement(children, {
          disabled: disabled,
          onClick: (e: React.MouseEvent<HTMLElement>) => {
            if (disabled) {
              e.preventDefault();
              setOpen(true);
            }
            if (!disabled && children.props.onClick) {
              children.props.onClick(e);
            }
          },
        })}
        {disabled && (
          <Tooltip title="Premium Feature">
            <IconButton
              size="small"
              sx={{
                ml: 0.5,
                bgcolor: 'background.paper',
                '&:hover': { bgcolor: 'background.paper' },
                width: 12,
                height: 12,
                minWidth: 12,
                minHeight: 12,
                p: 0.5,
              }}
              onClick={() => setOpen(true)}
            >
              <InfoIcon sx={{ fontSize: 10 }} color="primary" />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Premium Feature</DialogTitle>
        <DialogContent>
          <Typography>
            {featureName} is a premium feature available in our paid plan.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Upgrade to premium for just $1/month to unlock:
          </Typography>
          <ul>
            <li>Forum discussions</li>
            <li>Article comments</li>
            <li>Advanced search</li>
            <li>And more!</li>
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleUpgrade}>
            Upgrade Now
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
} 